export var HeaderTrackingElementName;
(function (HeaderTrackingElementName) {
    HeaderTrackingElementName["LOG_IN"] = "log_in";
    HeaderTrackingElementName["SIGN_IN"] = "sign_in";
    HeaderTrackingElementName["SIGN_UP"] = "sign_up";
    HeaderTrackingElementName["JOIN"] = "join";
    HeaderTrackingElementName["MY_ACCOUNT"] = "my_account";
    HeaderTrackingElementName["MY_ORDERS"] = "my_orders";
    HeaderTrackingElementName["CHECK_ORDER_STATUS"] = "check_order_status";
    HeaderTrackingElementName["SHIPPING_RETURNS"] = "shipping_returns";
    HeaderTrackingElementName["DISPLATE_CLUB"] = "displate_club";
    HeaderTrackingElementName["LUMINO"] = "lumino";
})(HeaderTrackingElementName || (HeaderTrackingElementName = {}));
//# sourceMappingURL=header.js.map